import React from "react";
import { useAuth } from "@/context/AuthContext";
import { Navigate } from "react-router-dom";
import { LogIn, Shield, GraduationCap, Sparkles } from "lucide-react";

import { IMG } from "@/lib/api";

const HERO = IMG.packSnow;

export default function Login() {
  const { user, login } = useAuth();
  if (user) return <Navigate to="/dashboard" replace />;
  return (
    <section className="relative min-h-[80vh] w-full overflow-hidden">
      <img src={HERO} alt="" className="absolute inset-0 h-full w-full object-cover" />
      <div className="absolute inset-0 bg-background/85" />
      <div className="relative container-x py-24 grid grid-cols-1 lg:grid-cols-2 gap-12 items-center">
        <div>
          <div className="eyebrow">Member Login</div>
          <h1 className="font-display text-5xl md:text-7xl leading-[0.98] mt-3 tracking-tight text-balance">Welcome back to the Village.</h1>
          <p className="mt-6 text-muted-foreground max-w-lg text-pretty">Sign in with Google to access your certifications, saved courses, event RSVPs and member community.</p>
          <button onClick={login} data-testid="login-google" className="btn-primary mt-8">
            <LogIn className="h-4 w-4" /> Continue with Google
          </button>
          <div className="mt-6 text-xs text-muted-foreground">By continuing, you agree to our Terms of Use and Privacy Policy.</div>
        </div>
        <div className="grid gap-4">
          {[
            { i: GraduationCap, t: "Track certifications", d: "Progress, badges and completion certificates in one place." },
            { i: Shield, t: "Save your library", d: "Bookmarks, downloaded resources and enrollment history." },
            { i: Sparkles, t: "Members-only events", d: "RSVP to workshops, live Q&As and chapter meetups." },
          ].map((f, i) => {
            const Icon = f.i;
            return (
              <div key={i} className="rounded-lg border border-border bg-card p-5 flex items-start gap-4">
                <div className="h-10 w-10 rounded-md bg-primary/10 text-primary grid place-items-center"><Icon className="h-4 w-4" /></div>
                <div>
                  <div className="font-display text-xl">{f.t}</div>
                  <div className="text-sm text-muted-foreground">{f.d}</div>
                </div>
              </div>
            );
          })}
        </div>
      </div>
    </section>
  );
}
